import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from './billsDashboardStyles';
import { buildSummaryTiles, TILE_STATE } from './billsSummary';

/**
 * The figures across the top of the Bills page.
 *
 * They describe the company's whole book of bills, not the page the table happens to have loaded —
 * which is the point of the summary endpoint behind them. Counting over the loaded page was wrong the
 * moment a company had more bills than one page holds, and wrong without saying so.
 *
 * A figure the server cannot answer arrives as null and is rendered as an em dash, greyed. That is a
 * different state from "still loading", which also shows a dash but must not be greyed: styling a
 * pending figure as absent makes every reload look like a page full of broken tiles.
 */
export const BillsSummaryCards = _ref => {
  let summary = _ref.summary,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  const classes = useStyles();
  const tiles = buildSummaryTiles(summary, isLoading);
  return (
    /*#__PURE__*/
    /* tabIndex makes the scroller reachable: the cards overflow it on a narrow viewport, and without
       a focus target there is no way to reach the ones off-screen without a mouse. */
    React.createElement(Box, {
      className: classes.kpiRow,
      role: "group",
      "aria-label": "Bill summary",
      tabIndex: 0
    }, tiles.map(card => /*#__PURE__*/React.createElement(Box, {
      key: card.label,
      className: classes.kpiCard
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.kpiLabel
    }, card.label), /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      className: "".concat(classes.kpiValue, " ").concat(card.state === TILE_STATE.unavailable ? classes.kpiValueUnavailable : '')
    }, card.value), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.kpiHint
    }, card.hint))))
  );
};